export const translations = {
  en: {
    // Navigation
    program: 'Program',
    profile: 'Profile',
    settings: 'Settings',
    logout: 'Logout',
    trainees: 'Trainees',
    trainer: 'Trainer',
    trainee: 'Trainee',
    
    // Login
    login: 'Login',
    email: 'Email',
    password: 'Password',
    loggingIn: 'Logging in...',
    welcomeBack: 'Welcome back to your fitness journey',
    pleaseFillAllFields: 'Please fill in all fields.',
    registrationFailedUserNotAuthenticated: 'Registration failed: user not authenticated.',
    selectRole: 'Select Role',
    role: 'Role',
    
    // Program Page
    myFitnessProgram: 'My Fitness Program',
    day: 'Day',
    sets: 'Sets',
    reps: 'Reps',
    noExercisesForThisDay: 'No exercises for this day.',
    addExercise: 'Add Exercise',
    allMuscles: 'All muscles',
    searchExercise: 'Search exercise...',
    noExercisesFound: 'No exercises found',
    saveChanges: 'Save Changes',
    saving: 'Saving...',
    removeExercise: 'Remove exercise',
    minutes: 'Minutes',
    weight: 'Weight',
    
    // Trainees Page
    myTrainees: 'My Trainees',
    traineesDescription: 'Manage your trainees and their fitness programs',
    noTrainees: 'No trainees assigned',
    noTraineesDescription: 'You don\'t have any trainees assigned to you yet.',
    traineeProgram: 'Trainee Program',
    currentProgram: 'Current Program',
    backToList: 'Back to List',
    clickToViewProgram: 'Click to view program',
    loadingTrainees: 'Loading trainees...',
    selected: 'Selected',
    welcomeTrainer: 'Welcome, Trainer!',
    trainerInstructions: 'Select a trainee from the left panel to view and edit their fitness program. You can manage exercises, sets, reps, and program structure.',
    viewPrograms: 'View Programs',
    viewProgramsDesc: 'See all your trainees\' current fitness programs and their progress.',
    editPrograms: 'Edit Programs',
    editProgramsDesc: 'Modify exercises, sets, reps, and program structure for each trainee.',
    trackProgress: 'Track Progress',
    trackProgressDesc: 'Monitor your trainees\' fitness levels and program completion.',
    inviteTrainees: 'Invite Trainees',
    inviteTraineesDesc: 'Generate a code to invite new trainees to your program.',
    generateCode: 'Generate Code',
    invitationCode: 'Invitation Code',
    myInvitationCodes: 'My Invitation Codes',
    expires: 'Expires',
    active: 'Active',
    expired: 'Expired',
    ok: 'OK',
    maxCodesReached: 'You have reached the maximum limit of 5 codes. Please delete an existing code before generating a new one.',
    codeExpiresIn: 'This code expires in 24 hours. Share it with your trainee.',
    joinTrainer: 'Join Trainer Program',
    enterInvitationCode: 'Enter invitation code',
    joinProgram: 'Join Program',
    joining: 'Joining...',
    enterCode: 'Please enter a code',
    expiredCode: 'Code has expired',
    onlyTraineesCanJoin: 'Only trainees can join trainer programs',
    trainerNoProgram: 'Trainer has no program available. Please ask your trainer to create a program first.',
    joinedSuccessfully: 'Successfully joined trainer!',
    joinError: 'Error joining program',
    myTrainer: 'My Trainer',
    loadingTrainer: 'Loading trainer info...',
    trainerName: 'Name',
    trainerEmail: 'Email',
    trainerUsername: 'Username',
    assignedToTrainer: 'You are assigned to this trainer',
    disconnectTrainer: 'Disconnect',
    disconnectedSuccessfully: 'Trainer connection removed successfully.',
    
    // Settings
    language: 'Language',
    subscription: 'Subscription',
    currentSubscription: 'Current Subscription',
    upgrade: 'Upgrade',
    subscription_t0: 'Free',
    subscription_t1: 'Premium',
    subscriptionDescription: 'Upgrade to Premium to remove ads and unlock more features.',
    deleteAccount: 'Delete Account',
    deleteAccountWarning: 'Are you sure you want to delete your account? This action cannot be undone.',
    deleteAccountConfirm: 'Yes, Delete My Account',
    deletingAccount: 'Deleting account...',
    accountDeleted: 'Account deleted successfully',
    deleteAccountError: 'Error deleting account',
    
    // Errors
    notAuthenticated: 'Not authenticated',
    userNotFound: 'User not found',
    noProgramAssigned: 'No program assigned',
    programNotFound: 'Program not found',
    noProgramFound: 'No program found.',
    loadingProgram: 'Loading program...',
    
    // Generic Error Messages
    defaultError: 'An error occurred. Please try again.',
    networkError: 'Network error. Please check your internet connection and try again.',
    connectionError: 'Failed to connect. Please check your internet connection and try again.',
    invalidCode: 'Invalid code. Please check the code and try again.',
    saveError: 'Failed to save changes. Please try again.',
    loadError: 'Failed to load data. Please try again.',
    permissionError: 'You do not have permission to perform this action.',
    serverError: 'Server error. Please try again later.',
    unknownError: 'An unexpected error occurred. Please try again.',
    
    // Firebase Auth Errors
    invalidCredential: 'Invalid email or password. Please check your credentials and try again.',
    userDisabled: 'This account has been disabled. Please contact support.',
    authUserNotFound: 'No account found with this email address.',
    wrongPassword: 'Incorrect password. Please try again.',
    emailAlreadyInUse: 'An account with this email already exists.',
    weakPassword: 'Password is too weak. Please use a stronger password.',
    networkRequestFailed: 'Network error. Please check your internet connection and try again.',
    tooManyRequests: 'Too many failed attempts. Please try again later.',
    operationNotAllowed: 'This operation is not allowed. Please contact support.',
    popupClosedByUser: 'Sign-in was cancelled. Please try again if you want to sign in with Google.',
    cancelledPopupRequest: 'Please complete the sign-in in the popup or try again.',
    unauthorizedDomain: 'This domain is not authorized for sign-in. If you are the developer, add this domain in Firebase Console → Authentication → Settings → Authorized domains.',
    accountExistsWithDifferentCredential: 'An account already exists with this email using another sign-in method. Try signing in with email and password, or use the same method you used when you first registered.',
    defaultAuthError: 'An error occurred. Please try again.',
    
    // Firestore Errors
    firestoreError: 'Database error. Please try again.',
    firestorePermissionDenied: 'You do not have permission to perform this action.',
    firestoreUnavailable: 'Database is temporarily unavailable. Please try again later.',
    
    // Profile
    profileComingSoon: 'Profile (Coming Soon)',
    loadingProfile: 'Loading profile...',
    editProfile: 'Edit Profile',
    firstName: 'First Name',
    lastName: 'Last Name',
    age: 'Age',
    fitnessLevel: 'Fitness Level',
    fitnessGoals: 'Fitness Goals',
    goalsPlaceholder: 'Describe your fitness goals...',
    beginner: 'Beginner',
    intermediate: 'Intermediate',
    advanced: 'Advanced',
    cancel: 'Cancel',
    save: 'Save',
    quickStats: 'Quick Stats',
    bmi: 'BMI',
    bmiCategory: 'BMI Category',
    accountInfo: 'Account Info',
    memberSince: 'Member Since',
    lastLogin: 'Last Login',
    quickActions: 'Quick Actions',
    saveSuccess: 'Profile updated successfully!',
    usernameError: 'Username is already taken',
    username: 'Username',
    wantGymBro: 'Looking for a Gym Bro',
    socialMedia: 'Social Media',
    socialMediaPlaceholder: 'Instagram, Telegram, etc.',
    location: 'Location',
    city: 'City',
    country: 'Country',
    information: 'Information:',
    
    // AI Trainer
    aiTrainer: 'AI Trainer',
    selectProgramType: 'Select Program Type',
    selectLevel: 'Select Level',
    selectDays: 'Select Days',
    enterGoal: 'Enter your goal',
    getSuggestion: 'Get Program Suggestion',
    loadingSuggestion: 'Getting suggestion...',
    weekday_monday: 'Monday',
    weekday_tuesday: 'Tuesday',
    weekday_wednesday: 'Wednesday',
    weekday_thursday: 'Thursday',
    weekday_friday: 'Friday',
    weekday_saturday: 'Saturday',
    weekday_sunday: 'Sunday',
    suggestionError: 'Failed to get suggestion. Please try again.',
    dailyLimitReached: 'You have already used your daily program suggestion allowance. Please try again tomorrow.',
    programType_fullbody: 'Full-Body',
    programType_brosplit: 'Bro-Split',
    programType_ppl: 'Push-Pull-Legs',
    level_beginner: 'Beginner',
    level_intermediate: 'Intermediate',
    level_advanced: 'Advanced',
    days: 'Days',
    goal: 'Goal',
    suggestionResult: 'Suggested Program',
    tryAgain: 'Try Again',
    goal_weight_loss: 'Weight Loss',
    goal_muscle_gain: 'Muscle Gain',
    createProgram: 'Create Program',
    addDay: 'Add Day',
    deleteDay: 'Delete Day',
    register: 'Register',
    createAccount: 'Create your free account',
    confirmPassword: 'Confirm Password',
    registrationSuccess: 'Registration successful! You can now log in.',
    registering: 'Registering...',
    noAccount: "Don't have an account?",
    haveAccount: 'Already have an account?',
    forgotPassword: 'Forgot Password?',
    resetPassword: 'Reset Password',
    resetPasswordTitle: 'Reset Your Password',
    resetPasswordDescription: 'Enter your email address and we\'ll send you a link to reset your password.',
    resetPasswordSuccess: 'Password reset email sent! Please check your inbox.',
    resetPasswordError: 'Failed to send password reset email.',
    backToLogin: 'Back to Login',
    sendResetLink: 'Send Reset Link',
    sending: 'Sending...',
    setNewPassword: 'Set New Password',
    newPassword: 'New Password',
    resetting: 'Resetting...',
    passwordResetSuccessful: 'Password Reset Successful!',
    passwordResetSuccessMessage: 'Your password has been successfully changed. You can now log in with your new password.',
    verifyingLink: 'Verifying link...',
    invalidResetLink: 'Invalid or missing password reset link.',
    passwordsDoNotMatch: 'Passwords do not match.',
    passwordTooShort: 'Password must be at least 6 characters long.',
    programType: 'Program Type',
    daysPerWeek: 'Days per Week',
    acceptProgram: 'Accept Program',
    acceptLoading: 'Accepting...',
    acceptSuccess: 'Program accepted successfully!',
    acceptError: 'Failed to accept program',
    
    // GymBro
    gymbro: 'GymBro',
    lookingForGymBro: 'Looking for a Gym Bro',
    findAGymBro: 'Find a GymBro',
    wantGymBroWarning: 'Other people will see that you\'re looking for a gym partner. Your email, location, fitness level, and social media account will be visible to help them reach out to you.',
    fitnessLevelFilter: 'Filter by Fitness Level',
    locationFilter: 'Filter by Location',
    allLevels: 'All Levels',
    noTraineesFound: 'No trainees found',
    failedToLoadTrainees: 'Failed to load trainees.',
    
    // Blogs
    blogs: 'Blogs',
    blogsDescription: 'Discover expert fitness tips, effective workout plans, and valuable health insights to help you achieve your fitness goals.',
    allCategories: 'All Categories',
    minRead: 'min read',
    backToBlogs: 'Back to Blogs',
    blogNotFound: 'Blog not found',
    errorLoadingBlogs: 'Error loading blogs',
    errorLoadingBlog: 'Error loading blog',
    noBlogsFound: 'No blogs found',
    author: 'Author',
    published: 'Published',
    readingTime: 'Reading time',
    loading: 'Loading...',
    
    // Blog Categories
    category_fitness: 'Fitness',
    category_nutrition: 'Nutrition',
    category_workout: 'Workout',
    category_health: 'Health',
    category_wellness: 'Wellness',
    category_training: 'Training',
    category_diet: 'Diet',
    category_exercise: 'Exercise',
    category_motivation: 'Motivation',
    category_tips: 'Tips',
    category_beginner: 'Beginner',
    category_advanced: 'Advanced',
    category_weight_loss: 'Weight Loss',
    category_muscle_gain: 'Muscle Gain',
    category_cardio: 'Cardio',
    category_strength: 'Strength',
    category_flexibility: 'Flexibility',
    category_recovery: 'Recovery',
    category_supplements: 'Supplements',
    category_lifestyle: 'Lifestyle',
    category_product_guide: 'Product Guide',
  },
  tr: {
    // Navigation
    program: 'Program',
    profile: 'Profil',
    settings: 'Ayarlar',
    logout: 'Çıkış',
    trainees: 'Öğrenciler',
    trainer: 'Antrenör',
    trainee: 'Öğrenci',
    
    // Login
    login: 'Giriş',
    email: 'E-posta',
    password: 'Şifre',
    loggingIn: 'Giriş yapılıyor...',
    welcomeBack: 'Fitness yolculuğuna tekrar hoş geldin',
    pleaseFillAllFields: 'Lütfen tüm alanları doldurun.',
    registrationFailedUserNotAuthenticated: 'Kayıt başarısız: kullanıcı kimliği doğrulanamadı.',
    selectRole: 'Rol Seçin',
    role: 'Rol',
    
    // Program Page
    myFitnessProgram: 'Fitness Programım',
    day: 'Gün',
    sets: 'Set',
    reps: 'Tekrar',
    noExercisesForThisDay: 'Bu gün için egzersiz yok.',
    addExercise: 'Egzersiz Ekle',
    allMuscles: 'Tüm kaslar',
    searchExercise: 'Egzersiz ara...',
    noExercisesFound: 'Egzersiz bulunamadı',
    saveChanges: 'Değişiklikleri Kaydet',
    saving: 'Kaydediliyor...',
    removeExercise: 'Egzersizi kaldır',
    minutes: 'Dakika',
    weight: 'Ağırlık',
    
    // Trainees Page
    myTrainees: 'Öğrencilerim',
    traineesDescription: 'Öğrencilerinizi ve fitness programlarını yönetin',
    noTrainees: 'Atanmış öğrenci yok',
    noTraineesDescription: 'Henüz size atanmış öğrenciniz yok.',
    traineeProgram: 'Öğrenci Programı',
    currentProgram: 'Mevcut Program',
    backToList: 'Listeye Dön',
    clickToViewProgram: 'Programı görüntülemek için tıklayın',
    loadingTrainees: 'Öğrenciler yükleniyor...',
    selected: 'Seçildi',
    welcomeTrainer: 'Hoş geldin, Antrenör!',
    trainerInstructions: 'Sol panelden bir öğrenci seçerek ve fitness programınızı görüntüleyerek ve düzenleyerek yönetebilirsin. Egzersizleri, setleri, tekrarları ve program yapısını yönetebilirsin.',
    viewPrograms: 'Programları Görüntüle',
    viewProgramsDesc: 'Tüm öğrencilerinizin mevcut fitness programlarını ve ilerlemelerini görüntüleyin.',
    editPrograms: 'Programları Düzenle',
    editProgramsDesc: 'Her öğrenci için egzersizleri, setleri, tekrarları ve program yapısını değiştirin.',
    trackProgress: 'İlerlemeyi Takip Et',
    trackProgressDesc: 'Öğrencilerinizin fitness seviyelerini ve program tamamlama durumunu izleyin.',
    inviteTrainees: 'Öğrencileri Davet Et',
    inviteTraineesDesc: 'Yeni öğrencileri programınıza davet etmek için bir kod oluşturun.',
    generateCode: 'Kod Oluştur',
    invitationCode: 'Davet Kodu',
    myInvitationCodes: 'Davet Kodlarım',
    expires: 'Sona Erme',
    active: 'Aktif',
    expired: 'Süresi Doldu',
    ok: 'Tamam',
    maxCodesReached: 'Maksimum 5 kod limitine ulaştınız. Yeni kod oluşturmadan önce mevcut bir kodu silin.',
    codeExpiresIn: 'Bu kod 24 saat sonra sona erer. Kodu öğrencinize paylaşın.',
    joinTrainer: 'Antrenöre bağlan',
    enterInvitationCode: 'Davet kodunu girin',
    joinProgram: 'Antrenöre bağlan',
    joining: 'Katılıyor...',
    enterCode: 'Lütfen bir kod girin',
    expiredCode: 'Kod süresi doldu',
    onlyTraineesCanJoin: 'Sadece öğrenciler antrenör programlarına katılabilir',
    trainerNoProgram: 'Antrenörünüzde mevcut program yok. Lütfen önce antrenörünüzden bir program oluşturmasını isteyin.',
    joinedSuccessfully: 'Antrenöre başarıyla katıldınız!',
    joinError: 'Programa katılırken hata oluştu',
    myTrainer: 'Antrenör',
    loadingTrainer: 'Antrenör bilgileri yükleniyor...',
    trainerName: 'Ad',
    trainerEmail: 'E-posta',
    trainerUsername: 'Kullanıcı Adı',
    assignedToTrainer: 'Bu antrenöre bağlısınız',
    disconnectTrainer: 'Bağlantıyı kes',
    disconnectedSuccessfully: 'Antrenör bağlantısı başarıyla kaldırıldı.',
    
    // Settings
    language: 'Dil',
    subscription: 'Abonelik',
    currentSubscription: 'Mevcut Abonelik',
    upgrade: 'Yükselt',
    subscription_t0: 'Ücretsiz',
    subscription_t1: 'Premium',
    subscriptionDescription: 'Reklamları kaldırmak ve daha fazla özelliğin kilidini açmak için Premium\'a yükseltin.',
    deleteAccount: 'Hesabı Sil',
    deleteAccountWarning: 'Hesabınızı silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.',
    deleteAccountConfirm: 'Evet, Hesabımı Sil',
    deletingAccount: 'Hesap siliniyor...',
    accountDeleted: 'Hesap başarıyla silindi',
    deleteAccountError: 'Hesap silinirken hata oluştu',
    
    // Errors
    notAuthenticated: 'Kimlik doğrulanmadı',
    userNotFound: 'Kullanıcı bulunamadı',
    noProgramAssigned: 'Program atanmamış',
    programNotFound: 'Program bulunamadı',
    noProgramFound: 'Program bulunamadı.',
    loadingProgram: 'Program yükleniyor...',
    
    // Generic Error Messages
    defaultError: 'Bir hata oluştu. Lütfen tekrar deneyin.',
    networkError: 'Ağ hatası. Lütfen internet bağlantınızı kontrol edip tekrar deneyin.',
    connectionError: 'Bağlantı kurulamadı. Lütfen internet bağlantınızı kontrol edip tekrar deneyin.',
    invalidCode: 'Geçersiz kod. Lütfen kodu kontrol edip tekrar deneyin.',
    saveError: 'Değişiklikler kaydedilemedi. Lütfen tekrar deneyin.',
    loadError: 'Veri yüklenemedi. Lütfen tekrar deneyin.',
    permissionError: 'Bu işlemi gerçekleştirmek için izniniz yok.',
    serverError: 'Sunucu hatası. Lütfen daha sonra tekrar deneyin.',
    unknownError: 'Beklenmeyen bir hata oluştu. Lütfen tekrar deneyin.',
    
    // Firebase Auth Errors
    invalidCredential: 'Geçersiz e-posta veya şifre. Lütfen bilgilerinizi kontrol edip tekrar deneyin.',
    userDisabled: 'Bu hesap devre dışı bırakıldı. Lütfen destek ile iletişime geçin.',
    authUserNotFound: 'Bu e-posta adresiyle bir hesap bulunamadı.',
    wrongPassword: 'Yanlış şifre. Lütfen tekrar deneyin.',
    emailAlreadyInUse: 'Bu e-posta adresiyle zaten bir hesap mevcut.',
    weakPassword: 'Şifre çok zayıf. Lütfen daha güçlü bir şifre kullanın.',
    networkRequestFailed: 'Ağ hatası. Lütfen internet bağlantınızı kontrol edip tekrar deneyin.',
    tooManyRequests: 'Çok fazla başarısız deneme. Lütfen daha sonra tekrar deneyin.',
    operationNotAllowed: 'Bu işleme izin verilmiyor. Lütfen destek ile iletişime geçin.',
    popupClosedByUser: 'Giriş iptal edildi. Google ile giriş yapmak istiyorsanız tekrar deneyin.',
    cancelledPopupRequest: 'Lütfen açılan pencerede girişi tamamlayın veya tekrar deneyin.',
    unauthorizedDomain: 'Bu alan adı giriş için yetkili değil. Geliştirici iseniz Firebase Console → Authentication → Settings → Authorized domains bölümüne bu alan adını ekleyin.',
    accountExistsWithDifferentCredential: 'Bu e-posta ile başka bir giriş yöntemiyle zaten bir hesap var. E-posta ve şifre ile giriş yapın veya ilk kayıtta kullandığınız yöntemi kullanın.',
    defaultAuthError: 'Bir hata oluştu. Lütfen tekrar deneyin.',
    
    // Firestore Errors
    firestoreError: 'Veritabanı hatası. Lütfen tekrar deneyin.',
    firestorePermissionDenied: 'Bu işlemi gerçekleştirmek için izniniz yok.',
    firestoreUnavailable: 'Veritabanı geçici olarak kullanılamıyor. Lütfen daha sonra tekrar deneyin.',
    
    // Profile
    profileComingSoon: 'Profil (Yakında)',
    loadingProfile: 'Profil yükleniyor...',
    editProfile: 'Profili Düzenle',
    firstName: 'Ad',
    lastName: 'Soyad',
    age: 'Yaş',
    fitnessLevel: 'Fitness Seviyesi',
    fitnessGoals: 'Fitness Hedefleri',
    goalsPlaceholder: 'Fitness hedeflerinizi açıklayın...',
    beginner: 'Başlangıç',
    intermediate: 'Orta',
    advanced: 'İleri',
    cancel: 'İptal',
    save: 'Kaydet',
    quickStats: 'Hızlı İstatistikler',
    bmi: 'VKİ',
    bmiCategory: 'VKİ Kategorisi',
    accountInfo: 'Hesap Bilgileri',
    memberSince: 'Üyelik Tarihi',
    lastLogin: 'Son Giriş',
    quickActions: 'Hızlı İşlemler',
    saveSuccess: 'Profil başarıyla güncellendi!',
    usernameError: 'Kullanıcı adı zaten alınmış',
    username: 'Kullanıcı Adı',
    wantGymBro: 'Gym Bro Arıyorum',
    socialMedia: 'Sosyal Medya',
    socialMediaPlaceholder: 'Instagram, Telegram, vb.',
    location: 'Konum',
    city: 'Şehir',
    country: 'Ülke',
    information: 'Bilgi:',
    
    // AI Trainer
    aiTrainer: 'AI Antrenör',
    selectProgramType: 'Program Türü',
    selectLevel: 'Seviye',
    selectDays: 'Günleri Seçin',
    enterGoal: 'Hedefinizi girin',
    getSuggestion: 'Program Önerisi Al',
    loadingSuggestion: 'Öneri alınıyor...',
    weekday_monday: 'Pazartesi',
    weekday_tuesday: 'Salı',
    weekday_wednesday: 'Çarşamba',
    weekday_thursday: 'Perşembe',
    weekday_friday: 'Cuma',
    weekday_saturday: 'Cumartesi',
    weekday_sunday: 'Pazar',
    suggestionError: 'Öneri alınamadı. Lütfen tekrar deneyin.',
    dailyLimitReached: 'Günlük program önerisi hakkınızı zaten kullandınız. Lütfen yarın tekrar deneyin.',
    programType_fullbody: 'Tam Vücut',
    programType_brosplit: 'Bro Split',
    programType_ppl: 'Push Pull Legs',
    level_beginner: 'Başlangıç',
    level_intermediate: 'Orta',
    level_advanced: 'İleri',
    days: 'Günler',
    goal: 'Hedef',
    suggestionResult: 'Önerilen Program',
    tryAgain: 'Tekrar Dene',
    goal_weight_loss: 'Kilo Verme',
    goal_muscle_gain: 'Kas Kazanma',
    createProgram: 'Program Oluştur',
    addDay: 'Gün Ekle',
    deleteDay: 'Günü Sil',
    register: 'Kayıt Ol',
    createAccount: 'Ücretsiz hesabınızı oluşturun',
    confirmPassword: 'Şifreyi Onayla',
    registrationSuccess: 'Kayıt başarılı! Lütfen giriş yapın.',
    registering: 'Kaydediliyor...',
    noAccount: 'Hesabınız yok mu?',
    haveAccount: 'Zaten hesabınız var mı?',
    forgotPassword: 'Şifrenizi mi Unuttunuz?',
    resetPassword: 'Şifreyi Sıfırla',
    resetPasswordTitle: 'Şifrenizi Sıfırlayın',
    resetPasswordDescription: 'E-posta adresinizi girin, size şifre sıfırlama bağlantısı gönderelim.',
    resetPasswordSuccess: 'Şifre sıfırlama e-postası gönderildi! Lütfen gelen kutunuzu kontrol edin.',
    resetPasswordError: 'Şifre sıfırlama e-postası gönderilemedi.',
    backToLogin: 'Girişe Dön',
    sendResetLink: 'Sıfırlama Bağlantısı Gönder',
    sending: 'Gönderiliyor...',
    setNewPassword: 'Yeni Şifre Belirle',
    newPassword: 'Yeni Şifre',
    resetting: 'Sıfırlanıyor...',
    passwordResetSuccessful: 'Şifre Başarıyla Sıfırlandı!',
    passwordResetSuccessMessage: 'Şifreniz başarıyla değiştirildi. Artık yeni şifrenizle giriş yapabilirsiniz.',
    verifyingLink: 'Bağlantı doğrulanıyor...',
    invalidResetLink: 'Geçersiz veya eksik şifre sıfırlama bağlantısı.',
    passwordsDoNotMatch: 'Şifreler eşleşmiyor.',
    passwordTooShort: 'Şifre en az 6 karakter olmalıdır.',
    programType: 'Program Türü',
    daysPerWeek: 'Haftalık Gün Sayısı',
    acceptProgram: 'Programı Kabul Et',
    acceptLoading: 'Kabul ediliyor...',
    acceptSuccess: 'Program başarıyla kabul edildi!',
    acceptError: 'Program kabul edilemedi',
    
    // GymBro
    gymbro: 'GymBro',
    lookingForGymBro: 'Gym Bro Arıyorum',
    findAGymBro: 'GymBro Bul',
    wantGymBroWarning: 'Diğer kişiler bir spor partneri aradığınızı görecek. Size ulaşmalarına yardımcı olmak için e-posta adresiniz, konumunuz, fitness seviyeniz ve sosyal medya hesabınız görünür olacak.',
    fitnessLevelFilter: 'Fitness Seviyesine Göre Filtrele',
    locationFilter: 'Konuma Göre Filtrele',
    allLevels: 'Tüm Seviyeler',
    noTraineesFound: 'Öğrenci bulunamadı',
    failedToLoadTrainees: 'Öğrenciler yüklenemedi.',
    
    // Blogs
    blogs: 'Bloglar',
    blogsDescription: 'Uzman fitness ipuçları, etkili antrenman programları ve değerli sağlık bilgileri keşfedin. Fitness hedeflerinize ulaşmanıza yardımcı olacak içerikler burada.',
    allCategories: 'Tüm Kategoriler',
    minRead: 'dakika okuma',
    backToBlogs: 'Bloglara Dön',
    blogNotFound: 'Blog bulunamadı',
    errorLoadingBlogs: 'Bloglar yüklenirken hata oluştu',
    errorLoadingBlog: 'Blog yüklenirken hata oluştu',
    noBlogsFound: 'Blog bulunamadı',
    author: 'Yazar',
    published: 'Yayın Tarihi',
    readingTime: 'Okuma Süresi',
    loading: 'Yükleniyor...',
    
    // Blog Categories
    category_fitness: 'Fitness',
    category_nutrition: 'Beslenme',
    category_workout: 'Antrenman',
    category_health: 'Sağlık',
    category_wellness: 'Sağlıklı Yaşam',
    category_training: 'Eğitim',
    category_diet: 'Diyet',
    category_exercise: 'Egzersiz',
    category_motivation: 'Motivasyon',
    category_tips: 'İpuçları',
    category_beginner: 'Başlangıç',
    category_advanced: 'İleri Seviye',
    category_weight_loss: 'Kilo Verme',
    category_muscle_gain: 'Kas Kazanma',
    category_cardio: 'Kardiyovasküler',
    category_strength: 'Güç',
    category_flexibility: 'Esneklik',
    category_recovery: 'Toparlanma',
    category_supplements: 'Takviyeler',
    category_lifestyle: 'Yaşam Tarzı',
    category_product_guide: 'Ürün Rehberi',
  }
};

export const getTranslation = (language, key) => {
  return translations[language]?.[key] || key;
};

// Helper function to translate blog category names
export const translateCategory = (category, language = 'tr') => {
  if (!category) return '';
  
  // Normalize category: convert to lowercase and replace spaces/hyphens with underscores
  const normalizedCategory = category.toLowerCase().replace(/[\s-]/g, '_');
  const translationKey = `category_${normalizedCategory}`;
  
  // Try to get translation
  const translated = getTranslation(language, translationKey);
  
  // If translation exists and is different from the key, return it
  if (translated !== translationKey) {
    return translated;
  }
  
  // If no translation found, return formatted category name
  return category.replace(/-/g, ' ').replace(/_/g, ' ');
};

// Helper function to translate Firebase authentication errors to user-friendly messages
export const getFirebaseAuthError = (error, language = 'en') => {
  if (!error || !error.code) {
    return getTranslation(language, 'defaultAuthError');
  }

  const errorCode = error.code;
  
  // Map Firebase error codes to translation keys
  const errorMap = {
    'auth/invalid-credential': 'invalidCredential',
    'auth/invalid-email': 'invalidCredential',
    'auth/user-disabled': 'userDisabled',
    'auth/user-not-found': 'authUserNotFound',
    'auth/wrong-password': 'wrongPassword',
    'auth/email-already-in-use': 'emailAlreadyInUse',
    'auth/weak-password': 'weakPassword',
    'auth/network-request-failed': 'networkRequestFailed',
    'auth/too-many-requests': 'tooManyRequests',
    'auth/operation-not-allowed': 'operationNotAllowed',
    'auth/popup-closed-by-user': 'popupClosedByUser',
    'auth/cancelled-popup-request': 'cancelledPopupRequest',
    'auth/unauthorized-domain': 'unauthorizedDomain',
    'auth/account-exists-with-different-credential': 'accountExistsWithDifferentCredential',
  };

  const translationKey = errorMap[errorCode] || 'defaultAuthError';
  return getTranslation(language, translationKey);
};

// Helper function to convert any error/exception to a user-friendly message
export const getUserFriendlyError = (error, language = 'en') => {
  if (!error) {
    return getTranslation(language, 'defaultError');
  }

  // If it's a Firebase Auth error, use the existing handler
  if (error.code && error.code.startsWith('auth/')) {
    return getFirebaseAuthError(error, language);
  }

  // Handle Firebase Firestore errors
  if (error.code) {
    const firestoreErrorMap = {
      'permission-denied': 'firestorePermissionDenied',
      'unavailable': 'firestoreUnavailable',
      'failed-precondition': 'firestoreError',
      'aborted': 'firestoreError',
      'out-of-range': 'firestoreError',
      'unimplemented': 'serverError',
      'internal': 'serverError',
      'data-loss': 'firestoreError',
    };
    
    const translationKey = firestoreErrorMap[error.code] || 'firestoreError';
    return getTranslation(language, translationKey);
  }

  // Handle error messages (string errors or Error objects)
  const errorMessage = typeof error === 'string' ? error : (error.message || error.toString() || '');
  const lowerMessage = errorMessage.toLowerCase();

  // Check for specific error patterns and map them to user-friendly messages
  if (lowerMessage.includes('invalid code') || lowerMessage.includes('exception: invalid code')) {
    return getTranslation(language, 'invalidCode');
  }
  
  if (lowerMessage.includes('failed to connect') || lowerMessage.includes('connection') || lowerMessage.includes('network')) {
    return getTranslation(language, 'connectionError');
  }
  
  if (lowerMessage.includes('permission') || lowerMessage.includes('access denied')) {
    return getTranslation(language, 'permissionError');
  }
  
  if (lowerMessage.includes('not authenticated') || lowerMessage.includes('unauthenticated')) {
    return getTranslation(language, 'notAuthenticated');
  }
  
  if (lowerMessage.includes('user not found')) {
    return getTranslation(language, 'userNotFound');
  }
  
  if (lowerMessage.includes('no program') || lowerMessage.includes('program not found')) {
    if (lowerMessage.includes('assigned')) {
      return getTranslation(language, 'noProgramAssigned');
    }
    return getTranslation(language, 'programNotFound');
  }
  
  if (lowerMessage.includes('firestore')) {
    return getTranslation(language, 'firestoreError');
  }
  
  // If the error message is already a translation key, try to translate it
  const possibleKey = errorMessage.trim();
  const translated = getTranslation(language, possibleKey);
  if (translated !== possibleKey) {
    return translated;
  }

  // Default fallback
  return getTranslation(language, 'defaultError');
}; 